import { UserProfilePrefs } from '../../../Helpers/UserProfilePrefs';
import { defaultUnits as defaultMetric } from '../../../../sustell_15/utils/unit-utils';
import {
  mapCommonInterventionDataIn,
  interventionFloatValueInUserUnits
} from './inCommonMapperSustell';

const mapLayingHensProductionDataInSustell = (inData) => {
  const userPrefs = UserProfilePrefs.getInstance();
  const userUOM = userPrefs.getUserUnitPrefs();
  const outputMassPrecision = userPrefs.getUnitOutputMassPrecision();
  const precision = userPrefs.getUnitBarnOutputMassPrecision();
  const formData = mapCommonInterventionDataIn(inData);
  inData.stages.forEach( (stage, index) => {
    const stageData = JSON.parse(stage.stageData) || {};
    if(formData.stages[index]){
      const stageOutputFormPart = formData.stages[index]?.stageData?.output;
      if(stageOutputFormPart){
        if (
          stageData?.eggs?.total_weight?.value ||
          stageData?.eggs?.total_weight?.value === 0
        ) {
          let eggsValue = stageData.eggs.total_weight.value;
          const eggValueChangeMetric = stageData?.eggs?.total_weight?.change_type || 'relative';
          eggsValue = interventionFloatValueInUserUnits(
            eggsValue,
            userUOM.unitOutputMass,
            defaultMetric.unitOutputMass,
            eggValueChangeMetric,
            outputMassPrecision
          );
          stageOutputFormPart.eggs = eggsValue;
          stageOutputFormPart.eggs_changeMetric = eggValueChangeMetric;
        }
      
        if (
          stageData?.spent_hens?.total_weight?.value ||
          stageData?.spent_hens?.total_weight?.value === 0
        ) {
          let liveWeight = stageData.spent_hens.total_weight.value;
          const liveWeightChangeMetric =
            stageData?.spent_hens?.total_weight?.change_type || 'relative';
          liveWeight = interventionFloatValueInUserUnits(
            liveWeight,
            userUOM.unitOutputMass,
            defaultMetric.unitOutputMass,
            liveWeightChangeMetric,
            outputMassPrecision
          );
          stageOutputFormPart.liveWeight = liveWeight;
          stageOutputFormPart.liveWeight_changeMetric = liveWeightChangeMetric;
        }
      }

      // map input data
      const stageInputFormPart = formData.stages[index]?.stageData?.input;
      if(stageInputFormPart){
        if (
          stageData?.purchased_laying_hens?.number_of_purchased_animals
            ?.value ||
            stageData?.purchased_laying_hens?.number_of_purchased_animals
            ?.value === 0
        ) {
          stageInputFormPart.purchasedAnimalsLayingHens =
            stageData?.purchased_laying_hens?.number_of_purchased_animals?.value;
          stageInputFormPart.purchasedAnimalsLayingHens_changeMetric =
            stageData?.purchased_laying_hens
              ?.number_of_purchased_animals?.change_type || 'relative';
        }

        stageInputFormPart.mortalityRate =
          stageData?.mortality?.mortality_rate?.value;
        stageInputFormPart.mortalityRate_changeMetric =
          stageData?.mortality?.mortality_rate?.change_type ||
          'relative';

        let avgMorVal =
          stageData?.mortality?.average_live_weight_mortalities?.value;
        const chgMetric =
          stageInputFormPart.averageLiveWeightMortalities_changeMetric;
        avgMorVal = interventionFloatValueInUserUnits(
          avgMorVal,
          userUOM.unitBarnOutputMass,
          defaultMetric.unitBarnOutputMass,
          chgMetric,
          precision
        );

        stageInputFormPart.averageLiveWeightMortalities = avgMorVal;
        stageInputFormPart.averageLiveWeightMortalities_changeMetric = chgMetric || 'relative';
      }
      formData.stages[index].productionSystem = stageData?.housing_description?.housing_type;
    }
      
  });
  return formData;
};

export default mapLayingHensProductionDataInSustell;
